export const SystemName = {
	ContainerTransportType: {
		Standard: "Standard",
		Side: "Side"
	},
	FlagType: {
		LocationUserCreated: "Location.UserCreated"
	},
	GeoCoordinateInformationType: {
		BoothsNotification: "BoothsNotification",
		GeneralEvent: "GeneralEvent",
		SignificantEvent: "SignificantEvent"
	},
	GoodsLoad: {
		Full: "Full",
		Empty: "Empty"
	},
	LocationType: {
		Address: "Address",
		Terminal: "Terminal",
		Area: "BLLArea",
		Port: "BLLPort",
		Park: "BLLPark",
		Client: "Client",
		ClientPortPark: "ClientPortPark"
	},
	CTLocationType: {
		Country: "Country",
		Port: "Port",
		Address: "Address",
		Terminal: "Terminal",
		Area: "Area",
		Park: "Park",
		Client: "Client",
		ClientPortPark: "ClientPortPark",
		Unpack: "Unpack",
		Pack: "Pack",
		Warehouse: "Warehouse"
	},
	MovementType: {
		Import: "Import",
		Export: "Export",
		Move: "Move"
	},
	NotificationType: {
		ConsignmentNotification: "ConsignmentNotification"
	},
	NotificationTransportType: {
		Email: "Email",
		Messaging: "Messaging",
		MessageMedia: "MessageMedia"
	},
	Setting: {
		PlumsailClaimFormBaseURL: "PlumsailClaimFormBaseURL"
	},
	JobType: {
		ExportFCLTransportOrder: "ExportFCLTransportOrder",
		ImportFCLTransportOrder: "ImportFCLTransportOrder"
	},
	ContainerTransport: {
		PortalContainerTransportContainerArrivingToday: "BLLPortalContainerTransportContainerArrivingToday",
		PortalContainerTransportContainerAtLocation: "BLLPortalContainerTransportContainerAtLocation",
		PortalContainerTransportContainerCompleted: "BLLPortalContainerTransportContainerCompleted",
		PortalContainerTransportContainerDashboard: "BLLPortalContainerTransportContainerDashboard",
		PortalContainerTransportContainerDashboardGrid: "BLLPortalContainerTransportContainerDashboardGrid",
		PortalContainerTransportContainerInStorageYard: "BLLPortalContainerTransportContainerInStorageYard",
		PortalContainerTransportOrderArrivingInDays: "BLLPortalContainerTransportOrderArrivingInDays",
		PortalContainerTransportOrderDashboard: "BLLPortalContainerTransportOrderDashboard",
		PortalContainerTransportOrderDashboardGrid: "BLLPortalContainerTransportOrderDashboardGrid",
		PortalContainerTransportOrderInTransit: "BLLPortalContainerTransportOrderInTransit",
		PortalContainerTransportOrderWatchlist: "BLLPortalContainerTransportOrderWatchlist",
		// Update when bll general freight stored procedures are implemented
		PortalGeneralFreightDashboard: "PortalGeneralFreightDashboard",
		PortalGeneralFreightNotYetDeparted: "PortalGeneralFreightNotYetDeparted",
		PortalGeneralFreightInTransit: "PortalGeneralFreightInTransit",
		PortalGeneralFreightArrivingDelivered: "PortalGeneralFreightArrivingDelivered",
		PortalGeneralFreightWatchlist: "PortalGeneralFreightWatchlist"
	}
};
